import { getStoreDisplayTime, hasStoreHoursData, storeIsOpen } from '@libs/common-next';
import type { DisplayStore } from '@libs/common-types';

export function getStoreHoursLabel(store: DisplayStore, currentDate: Date): string {
    return getStoreDisplayTime(store, currentDate, 'header');
}

export function getStoreCurrentDate(store: DisplayStore): Date {
    const timezonedDate = new Date().toLocaleString('en', {
        timeZone: store.TimeZone?.TimeZoneId,
    });

    return new Date(timezonedDate);
}

export type StoreLocatorHoursStatus = 'open' | 'closed' | 'unavailable';

export type StoreLocatorDetails = {
    hoursLabel: string;
    hoursStatus: StoreLocatorHoursStatus;
};

export function getStoreLocatorDetails(store: DisplayStore): StoreLocatorDetails {
    if (!hasStoreHoursData(store)) {
        return {
            hoursLabel: 'Hours Unavailable',
            hoursStatus: 'unavailable',
        };
    }

    const currentDate = getStoreCurrentDate(store);
    const hoursLabel = getStoreHoursLabel(store, currentDate);

    return {
        hoursLabel,
        hoursStatus: storeIsOpen(store, currentDate) ? 'open' : 'closed',
    };
}
